/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, Event, EventEmitter } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import type { EfbImg } from '../../atoms/img/img';
import { ArticleColorVariant } from '../../../types/colors.types';
import type { EfbButton } from '../../atoms/button/button';

@Component({
  tag: 'efb-article-slide',
  styleUrl: 'article-slide.scss',
  shadow: true,
})
export class EfbArticleSlide {
  /**
   * Props.
   */

  @Prop() heading: string;

  @Prop() img: EfbImg | string;

  @Memoize('img')
  get parsedImg(): EfbImg {
    return parseIfString(this.img);
  }

  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedButton(): EfbButton {
    return parseIfString(this.button);
  }

  @Prop() variant: ArticleColorVariant = 'pink';

  @Prop() modalTarget: string;

  /**
   * Events
   */

  @Event() efbOpenArticleModal: EventEmitter<{
    action: string;
    value: string;
  }>;

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <efb-click-action
          tagClass={`article-slide is-${this.variant}-variant`}
          name="open-article-modal"
          value={this.modalTarget}
          dataAnalytics={this.parsedButton?.dataAnalytics}
        >
          {/* Content */}
          <div class="content">
            {/* Titles */}
            <div class="text-wrapper">
              <h3 class="title" innerHTML={this.heading}>
                {''}
              </h3>
            </div>
            {/* Image */}
            <div class="image-wrapper">
              <efb-img class="image" {...this.parsedImg} />
            </div>
          </div>

          {/* CTA */}
          <div class="cta">
            <span>{this.parsedButton.text}</span>
            <efb-icon class="icon" name="rounded-arrow" />
          </div>
        </efb-click-action>
      </Host>
    );
  }
}
